(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[932],{

/***/ "fNMz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Warning", function() { return Warning; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Warning = function Warning(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 25.016C20.521 25.016 25.013 20.523 25.013 15C25.013 9.478 20.521 4.986 15 4.986C9.477 4.986 4.984 9.478 4.984 15C4.984 20.523 9.477 25.016 15 25.016ZM3 15C3 8.383 8.383 3 15 3C21.617 3 27 8.383 27 15C27 21.617 21.617 27 15 27C8.383 27 3 21.617 3 15ZM14.7474 8H15.3164C15.9884 8 16.5254 8.533 16.4994 9.174L16.1974 16.458C16.1724 17.064 15.6504 17.543 15.0154 17.543C14.3774 17.543 13.8544 17.061 13.8324 16.453L13.5644 9.169C13.5414 8.53 14.0774 8 14.7474 8ZM14.9914 22C15.7904 22 16.4384 21.382 16.4384 20.619C16.4384 19.856 15.7904 19.238 14.9914 19.238H14.9474C14.1474 19.238 13.5004 19.856 13.5004 20.619C13.5004 21.382 14.1474 22 14.9474 22H14.9914Z"
  }));
};

/***/ })

}]);